import { PropertyContent, PropertyInfo, SearchProperty } from "../utils/interface";

const Property = (api: any) => ({
  bulkCreatePropertyContents: (propertyId: number, propertyContent: any) =>
    api.post(`/api/v1/property/${propertyId}/content/bulk`, {}, propertyContent),
  createProperty: (propertyDetails: any) =>
    api.post('/api/v1/property/', {}, propertyDetails),
  createPropertyFeature: (propertyId: number, propertyFeatureInfo: any) =>
    api.post(`/api/v1/property/${propertyId}/feature`, {}, propertyFeatureInfo),
  createPropertyRent: (propertyId: number, propertyRentInfo: any) =>
    api.post(`/api/v1/property/${propertyId}/rent`, {}, propertyRentInfo),
  deletePropertyContent: (propertyContentId: number) =>
    api.remove(`/api/v1/content/${propertyContentId}`, {}, {}),
  deletePropertyFeature: (propertyId: number, propertyFeatureId: number, fromDate: string) =>
    api.remove(`/api/v1/property/${propertyId}/feature/${propertyFeatureId}`, {}, { fromDate }),
  deletePropertyRent: (propertyRentId: number) =>
    api.remove(`/api/v1/rent/${propertyRentId}`, {}, {}),
  getPropertyInfo: (propertyId: number) =>
    api.get(`/api/v1/property/${propertyId}`, {}, {}),
  getPropertyFeatures: (propertyId: number) =>
    api.get(`/api/v1/property/${propertyId}/feature`, {}, {}),
  getStatuses: () =>
    api.get('/api/v1/property/status', {}, {}),
  getPropertyContents: (propertyId: number) =>
    api.get(`/api/v1/property/${propertyId}/content`, {}, {}),
  getPropertyTypes: () =>
    api.get('/api/v1/property/type', {}, {}),
  getPropertyContentTypes: () =>
    api.get('/api/v1/property/content/type', {}, {}),
  getFeatureTypes: () =>
    api.get('/api/v1/property/feature/type', {}, {}),
  getPropertyRentalTypes: () =>
    api.get('/api/v1/rent/type', {}, {}),
  getFeatures: (propertyTypeEnumId: number) =>
    api.get(`/api/v1/property/feature/${propertyTypeEnumId}`, {}, {}),
  getPropertyRents: (propertyId: number) =>
    api.get(`/api/v1/property/${propertyId}/rent`, {}, {}),
  savePropertyLocation: (propertyId: number, propertyLocationValues: any) =>
    api.post(`/api/v1/property/${propertyId}/location`, {}, propertyLocationValues),
  searchProperty: ({
    propertyId,
    propertyTypeEnumId,
    isVerified,
    propertyTitle,
    ownerId,
    statusId,
    createdAt,
    pageIndex,
    pageSize,
  }: SearchProperty) => {
    const searchData = {
      propertyId,
      propertyTypeEnumId,
      isVerified,
      propertyTitle,
      ownerId,
      statusId,
      createdAt,
      pageIndex: pageIndex ? pageIndex : 0,
      pageSize: pageSize ? pageSize : 10,
    }
    return api.post('/api/v1/property/search', {}, searchData)
  },
  updateProperty: (propertyId: number, propertyDetails: PropertyInfo) =>
    api.put(`/api/v1/property/${propertyId}`, {}, propertyDetails),
  updatePropertyContent: (propertyContentId: number, propertyContent: PropertyContent) =>
    api.put(`/api/v1/content/${propertyContentId}`, {}, propertyContent),
  deleteProperty: (propertyId: number) =>
    api.remove(`/api/v1/property/${propertyId}`),
});

export default Property;
